import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import {Menu, Dropdown, Icon} from 'antd';

import * as mapActions from '../actions/map-actions';
import './CardMenu.css';

class CardMenu extends Component {
  render() {
    const onClick = function ({keyPath}) {
      const [field, key] = keyPath;

      console.log(keyPath)
      switch (key) {
        case 'x':
        case 'y':
          return this.props.actions.selectField(field.substring(2), key);
        case 'state':
          const stateFips = +field;
          return this.props.actions.selectState(stateFips);
        case 'county':
          const countyFips = +field;
          return this.props.actions.selectCounty(countyFips);
        case 'sex':
        case 'age':
        case 'race':
          return this.props.actions.selectDemographic(key, field);
        case 'reset':
        default:
          return this.props.actions.resetDemographics();
      }
    };

    const selectedKeys = [
      'X-' + this.props.xField,
      'Y-' + this.props.yField,
      '' + this.props.selectedState.fips,
      '' + this.props.selectedCounty.fips,
      this.props.selectedSex,
      this.props.selectedAge,
      this.props.selectedRace
    ];

    const shouldDisable = function (key) {
      return _.includes(selectedKeys, key);
    };

    const fieldsX = _.map(this.props.fields, f => {
      return (
        <Menu.Item key={'X-' + f.field} disabled={shouldDisable('Y-' + f.field)}>
          <a>
            {f.label}
            <div className="desc">{f.desc}</div>
          </a>
        </Menu.Item>
      )
    });

    const fieldsY = _.map(this.props.fields, f => {
      return (
        <Menu.Item key={'Y-' + f.field} disabled={shouldDisable('X-' + f.field)}>
          <a>
            {f.label}
            <div className="desc">{f.desc}</div>
          </a>
        </Menu.Item>
      )
    });

    const menu = (
      <Menu selectedKeys={selectedKeys} onClick={onClick.bind(this)} className="CardMenu">

        {this.props.showDimensions &&
        <Menu.ItemGroup title={
          <div>
            Dimension X
            <svg width={12} height={8}>
              <rect width={6} height={6} x={6} y={1} rx={1.5} ry={1.5}  fill="#c85a5a"></rect>
            </svg>
          </div>
        } children={
          <Menu.SubMenu key="x" title={this.props.xLabel}>{fieldsX}</Menu.SubMenu>
        }/>
        }

        {this.props.showDimensions &&
        <Menu.Divider/>
        }

        {this.props.showDimensions &&
        <Menu.ItemGroup title={
          <div>
            Dimension Y
            <svg width={12} height={8}>
              <rect width={6} height={6} x={5} y={1} rx={1.5} ry={1.5}  fill="#64acbe"></rect>
            </svg>
          </div>
        } children={
          <Menu.SubMenu key="y" title={this.props.yLabel}>{fieldsY}</Menu.SubMenu>
        }/>
        }

        {this.props.showDimensions &&
        <Menu.Divider/>
        }

        {this.props.showLocations &&
        <Menu.ItemGroup title="Selected State" children={
          <Menu.SubMenu key="state" title={this.props.selectedState.name}>{this.props.states}</Menu.SubMenu>
        }/>
        }

        {this.props.showLocations &&
        <Menu.Divider/>
        }

        {this.props.showLocations &&
        <Menu.ItemGroup title={'Selected ' + this.props.selectedState.abbr + ' County'} children={
          <Menu.SubMenu key="county" title={this.props.selectedCounty.name}>{this.props.counties}</Menu.SubMenu>
        }/>
        }

        {this.props.showDemographics &&
        <Menu.ItemGroup title="Sex" children={
          <Menu.SubMenu key="sex" title={this.props.selectedSex}>{this.props.sexes}</Menu.SubMenu>
        }/>
        }

        {this.props.showDemographics &&
        <Menu.Divider/>
        }

        {this.props.showDemographics &&
        <Menu.ItemGroup title="Age Group" children={
          <Menu.SubMenu key="age" title={this.props.selectedAge}>{this.props.ages}</Menu.SubMenu>
        }/>
        }

        {this.props.showDemographics &&
        <Menu.Divider/>
        }

        {this.props.showDemographics &&
        <Menu.ItemGroup title="Race-Origin" children={
          <Menu.SubMenu key="race" title={this.props.selectedRace}>{this.props.races}</Menu.SubMenu>
        }/>
        }

        {this.props.showDemographics &&
        <Menu.Divider/>
        }

        {this.props.showDemographics &&
        <Menu.Item key="reset" className="reset-demo">
          <Icon type="close-square-o"/> &nbsp;Reset Demographics
        </Menu.Item>
        }

      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={['click']}>
        <a className="ant-dropdown-link">
          {this.props.title} <Icon type="down"/>
        </a>
      </Dropdown>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    title: props.title,
    fields: store.dimensions.fields,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    selectedState: store.states.selected,
    selectedCounty: store.counties.selected,
    selectedSex: store.demographics.sex,
    selectedAge: store.demographics.age,
    selectedRace: store.demographics.race,
    states: _.map(store.states.list, s => {
      return (<Menu.Item key={s.fips}><a>{s.name}</a></Menu.Item>)
    }),
    counties: _.map(store.counties.list, c => {
      return (<Menu.Item key={c.fips}><a>{c.name}</a></Menu.Item>)
    }),
    sexes: _.map(store.demographics.sexes, d => {
      return (<Menu.Item key={d}><a>{d}</a></Menu.Item>)
    }),
    ages: _.map(store.demographics.ages, d => {
      return (<Menu.Item key={d}><a>{d}</a></Menu.Item>)
    }),
    races: _.map(store.demographics.races, d => {
      return (<Menu.Item key={d}><a>{d}</a></Menu.Item>)
    }),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(mapActions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(CardMenu);



// WEBPACK FOOTER //
// ./src/containers/CardMenu.js